/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */

import { getBaseServiceConfig } from 'apps/console-core/src/Services/_base';
import { useTenantSettingsServiceStore } from 'dxpConsoleCore-mf/State';
import { TenantSettingsService } from '../../TenantSettings.service';
import { TenantSettingsServiceConfiguration } from '../../TenantSettings.service.config';

/**
 * Get the Tenant Settings Service.
 */
export const getTenantSettingsService = (): TenantSettingsService => {
  const baseServiceConfig = getBaseServiceConfig();

  const { updateTenantSettingsService } = useTenantSettingsServiceStore.getState();
  const { tenantSettingsService }: { tenantSettingsService: TenantSettingsService | null } =
    useTenantSettingsServiceStore.getState();

  if (!tenantSettingsService) {
    const tenantSettingsServiceConfig: TenantSettingsServiceConfiguration = baseServiceConfig;
    const newTenantSettingsService = new TenantSettingsService(tenantSettingsServiceConfig);
    updateTenantSettingsService(newTenantSettingsService);

    return newTenantSettingsService;
  }

  return tenantSettingsService;
};
